import * as React from "react";
import { connect } from "react-redux";
import { StoreState } from "./store/storeState";
import { Switch, Route, RouteComponentProps, withRouter } from "react-router-dom";
import { NavItem } from "./navItems";
import PrivateRoute from "src/common/Components/PrivateRoute";
import { CustomerState } from "./types/authentication";
import asyncComponent from "./components/common/asyncComponent";
import AppointmentSurveyPage from "./components/Surveys/AppointmentSurveyPage";

const MemberIdentity = asyncComponent(() => import("./components/MemberIdentity/MemberIdentity"));
const InternalMemberIdentity = asyncComponent(() => import("./components/MemberIdentity/InternalMemberIdentity"));

interface RoutesReduxProps {
  authentication: CustomerState;
  isInternal: boolean;
}

interface RoutesOwnProps {
  navItems: NavItem[];
}

interface RoutesProps extends RoutesReduxProps, RouteComponentProps<any>, RoutesOwnProps {}

class Routes extends React.PureComponent<RoutesProps> {
  getPrivateRoute = (n: NavItem) => {
    return (
      <PrivateRoute
        isAuthenticated={this.props.authentication.isSignedIn}
        hasPermission={true}
        key={n.title}
        exact={n.exact}
        path={n.path}
        component={n.component}
      />
    );
  };

  render() {
    const { isInternal, location, navItems } = this.props;
    const logInComp = isInternal ? InternalMemberIdentity : MemberIdentity;
    return (
      <Switch key={location ? location.pathname : "/login"}>
        <Route key={"login"} exact={true} path="/login" component={logInComp} />
        <Route key="survey" title="Survey" exact={true} path="/survey/:apptId" component={AppointmentSurveyPage} />
        {navItems.map(n => this.getPrivateRoute(n))}
      </Switch>
    );
  }
}
const mapStateToProps = (state: StoreState, ownProps: RoutesOwnProps): RoutesReduxProps & RoutesOwnProps => {
  return {
    ...ownProps,
    isInternal: state.appSettings.isInternal,
    authentication: state.authentication
  };
};

export default withRouter(connect(mapStateToProps)(Routes));
